<template>
    <div class="header">
        <!-- logo-->
        <div class="header-left"></div>
        <div class="header-middle">
            <ul class="nav-wrap">
                <li @click="isClick = 0"><a href="#" :class="isClick == '0' ? 'current' : ''">首页</a></li>
                <li @click="isClick = 1"><a href="#" target="_self" :class="isClick == '1' ? 'current' : ''">售后公关</a></li>
                <li @click="isClick = 2"><a href="#"  target="_self" :class="isClick == '2' ? 'current' : ''">文章干货</a></li>
                <li @click="isClick = 3"><a href="#"  target="_self" :class="isClick == '3' ? 'current' : ''">联系我们</a></li>
            </ul>
            <div class="icon-wrap">
                <!-- <div class="news"></div> -->
				<div @click='jumpTo("./notice-switch")'>
					<el-badge is-dot class="news"></el-badge>
				</div>
                <div class="notice" @click='jumpTo("./my-news")'></div>
            </div>
        </div>

        <div class="header-right"  @click='jumpTo("./personal-data")'>
            <!-- 用户头像 -->
            <img :src="userIcon" v-show="userInfo.user_icon" />
            <img src="../assets/img/user_icon.png" v-show="!userInfo.user_icon" />
            <span class="user-name">{{userInfo.user_name}}</span>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            isClick: 0
        };
    },

    computed: {
        ...mapState(['userInfo', 'communalInfo']),
      userIcon(){
          return this.httpFilterFUN(this.userInfo.user_icon) ? this.userInfo.user_icon : this.communalInfo.BucketDomain + this.userInfo.user_icon
      }
    },

    created() {
        this.getUserInfo();
    },

    methods: {
        ...mapActions(['getUserInfo']),
		jumpTo(url){
			this.$router.push({path:url})
		},

    httpFilterFUN(valueStr) {
        if (valueStr != "" && valueStr != null) {
          if (valueStr.indexOf("www") >= 0 || valueStr.indexOf("http") >= 0 || valueStr.indexOf("https") >= 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    }
};
</script>
<style lang="scss" scoped>
.header {
    z-index: 2;
    display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    max-width: 1440px;
    margin: 0 auto;
    height: 84px;
    font-size: 22px;
    color: #fff;
    background: #ffffff;
    box-shadow: 1px 13px 20px 1px rgba(0, 0, 0, 0.06);
}
.header-left {
    width: 240px;
    height: 100%;
    background: url('../assets/img/logo.png') no-repeat center center;
    background-size: 123px 32px;
    float: left;
    margin-right: 64px;
}
.header-middle {
    float: left;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;
    box-shadow: 1px 0px 1px 0 rgba(0, 0, 0, 0.06);
}
.nav-wrap {
    float: left;
}
.nav-wrap li {
    float: left;
	text-align: center;
    width: 80px;
    height: 84px;
    line-height: 100%;
    margin-right: 34px;
}

.nav-wrap a {
    width: 100%;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    display: inline-block;
    height: 100%;
    line-height: 84px;
    color: #333333;
}
.nav-wrap .current {
    border-bottom: 4px solid #ff8d1c;
    font-weight: bold;
    color: #000000;
}
.icon-wrap {
    float: left;
    display: flex;
    align-items: center;
}
.news {
    width: 16px;
    height: 16px;
    background: url('../assets/img/news.png') no-repeat center center;
    background-size: 100%;
	cursor: pointer;
}

.notice {
    width: 16px;
    height: 17px;
    background: url('../assets/img/notice.png') no-repeat center center;
    background-size: 100%;
    margin-left: 30px;
	cursor: pointer;
}

.header-right {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 50px;
	cursor: pointer;
	
}

.header-right img {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
}

.user-name {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-left: 20px;
}
.news >>> .el-badge__content.is-dot {
    width: 6px;
    height: 6px;
    position: absolute;
    right: -4px;
    top: -4px;
}
</style>
